import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

export const ANALYTICS = {
  analyticsPage: AnalyticsPageOrganization.OrganizationRole,
};
